// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3G3f_","inner":"Footer_inner__2D2tS","nextIcon":"Footer_nextIcon__3BPwo","innerLeft":"Footer_innerLeft__1qSzj"};